import cn from 'classnames';
import he from 'he';

import type { Locale } from '@shared/libs';
import { unbounded } from '@shared/ui';
import styles from './player.module.css';

type TProps = {
  locale: Locale;
};

export const Player = ({ locale }: TProps) => (
  <a href="#ai-player" className={styles.wrap}>
    <span className={cn(unbounded.className, styles.title)}>
      {he.decode(locale.NOTE_BANNER_PLAYER_TITLE || 'NOTE_BANNER_PLAYER_TITLE')}
    </span>
    <span className={styles.text}>
      {he.decode(locale.NOTE_BANNER_PLAYER_TEXT || 'NOTE_BANNER_PLAYER_TEXT')}
    </span>
  </a>
);
